import 'client-only';

import { useContext, useMemo } from 'react';

import { DataProviderContext } from '@/components/flow/components/DataProvider/DataProviderContext';
import { type Flags } from '@/types/productSelectionAndCheckout/types';

export const useProductSelectionCheckoutAndCartCheckoutFlags = (): Flags => {
  const data = useContext(DataProviderContext);

  return useMemo(() => {
    const flags =
      data?.productSelection?.flags ??
      data?.checkout?.flags ??
      data?.cartCheckout?.flags;

    if (!flags) {
      throw new Error(
        'useProductSelectionCheckoutAndCartCheckoutFlags can only be used within a DataProvider for one of the keys: productSelection, checkout, or cartCheckout.',
      );
    }

    return flags;
  }, [data?.cartCheckout, data?.checkout, data?.productSelection]);
};
